import classNames from 'classnames';
import { useContext } from 'react';
import { LangContext } from '../context';

const DeviceCard = ({status, udid, name, reg_date, t, openModalCard, countdown=null, revokeDate=null, instructionUrl=null, setShowModelApp, setShowModal}) => {
    const Lang = useContext(LangContext);
    
    
    function openInstructions() {
            window.open(instructionUrl, '_blank');
    }
    function formatTimeRemaining(days, hours, minutes, language = 'ru') {
    if (language === 'ru') {
        const dayWord = (days % 10 === 1 && days % 100 !== 11) ? "день" :
                       (2 <= days % 10 && days % 10 <= 4 && !(12 <= days % 100 && days % 100 <= 14)) ? "дня" : "дней";
        
        const hourWord = (hours % 10 === 1 && hours % 100 !== 11) ? "час" :
                        (2 <= hours % 10 && hours % 10 <= 4 && !(12 <= hours % 100 && hours % 100 <= 14)) ? "часа" : "часов";
        
        const minuteWord = (minutes % 10 === 1 && minutes % 100 !== 11) ? "минута" :
                          (2 <= minutes % 10 && minutes % 10 <= 4 && !(12 <= minutes % 100 && minutes % 100 <= 14)) ? "минуты" : "минут";
        
        const parts = [];
        if (days !== 0) parts.push(`${days} ${dayWord}`);
        if (hours > 0) parts.push(`${hours} ${hourWord}`);
        if (minutes > 0) parts.push(`${minutes} ${minuteWord}`);
        return parts.join(" ");
        
    } else if (language === 'en') {
        const parts = [];
        if (days !== 0) parts.push(`${days} day${days > 1 ? 's' : ''}`);
        if (hours > 0) parts.push(`${hours} hour${hours > 1 ? 's' : ''}`);
        if (minutes > 0) parts.push(`${minutes} minute${minutes > 1 ? 's' : ''}`);
        return parts.join(", ");
    }
    return "Language not supported";
    }

    function normalizeTime(timeInSeconds) {
        const days = Math.floor(timeInSeconds / 86400);
        const hours = Math.floor((timeInSeconds / 3600) % 24);
        const minutes = Math.floor((timeInSeconds / 60) % 60);
        return [days, hours, minutes];
    }

    function _(key, language = 'ru') {
        const translations = {
            'ru': {
                'Time remaining: ': 'Оставшееся время: ',
                'Expired': 'Истек срок'
            },
            'en': {
                'Time remaining: ': 'Time remaining: ',
                'Expired': 'Expired'
            }
        };
        return translations[Lang.Lang][key] || key;
    }

    // Альтернативный способ - если у вас уже есть время в секундах
    function generateTimeRemainingTextFromSeconds(seconds, language = 'ru') {
        const registrationTime = new Date(reg_date);

        const expirationTime = new Date(registrationTime.getTime() + seconds);

        const now = new Date();
        
        const enablesInSeconds = Math.floor((expirationTime.getTime() - now.getTime()) / 1000);
    
        let text = "";
        
        if (enablesInSeconds <= 0) {
            text +=  _('Expired', Lang.Lang) + '\n';
            return text;
        }
        
        const [days, hours, minutes] = normalizeTime(enablesInSeconds);
        text += formatTimeRemaining(days, hours, minutes, Lang.Lang) + '\n';
        
        return text;
    }
    return(
        <div className={classNames("device-card", status)} data-udid={udid} onClick={(!revokeDate && status !== 'extended' && status !== 'waiting' && status !== 'expired') ? openModalCard : () => {}}>
                <div className={classNames("status-badge", status)}>
                    <i className={classNames("fas", (status === 'expired' ? 'fa-clock' : status === 'extended' ? 'fa-exclamation-triangle' : status === "ready" ? "fa-check-circle" : status === "revoked" ? "fa-times-circle": "fa-hourglass-half"))}></i>
                    <span>{t(status)}</span>
                </div>
                
                <div className="device-info">
                    <h3>{name}</h3>
                    
                    <div className="info-row">
                        <i className="fas fa-user info-icon"></i>
                        <span className="info-label">{t('name')}:</span>
                        <span className="info-value">{name}</span>
                    </div>
                    
                    <div className="info-row"> 
                        <i className="fas fa-calendar info-icon"></i>
                        <span className="info-label">{t('reg_date')}:</span>
                        <span className="info-value">{reg_date}</span>
                    </div>
                </div>

                { (status === 'waiting' || status === 'extended') && (<div className="countdown-section">
                        <div className="countdown-title">
                            <i className="fas fa-stopwatch"></i>
                            <span>{t('remainingText')}:</span>
                        </div>
                        <div className={classNames("countdown-value", status)}>
                            {(status === 'waiting') ? generateTimeRemainingTextFromSeconds((3 * 24 * 60 * 60 * 1000) + (12 * 60 * 60 * 1000)) : generateTimeRemainingTextFromSeconds((33 * 24 * 60 * 60 * 1000) + (12 * 60 * 60 * 1000))}
                        </div>
                    </div>)
                }
                {
                    revokeDate && ( <div className="revoke-date">
                        <div className="info-row">
                            <i className="fas fa-ban info-icon"></i>
                            <span className="info-label">Отзыв:</span>
                            <span className="info-value">{revokeDate}</span>
                        </div>
                    </div>)
                }
                <div className="udid-section">
                    <div className="udid-title">
                        <i className="fas fa-mobile-alt"></i>
                        <span>UDID:</span>
                    </div>
                    <div className="udid-value">{udid}</div>
                </div>
                    
               <div className="action-buttons">
                    
                    <button className={classNames("action-btn sign-app-btn", (!revokeDate && status !== 'extended' && status !== 'waiting' && status !== 'expired') ? "" : "disabled")} onClick={() => {setShowModelApp(true) ; setTimeout(() => {setShowModal(null)}, 100)}}>
                        <i className="fas fa-signature"></i>
                        <span>{t('signApp')}</span>
                    </button>

                    {
                    instructionUrl ? (<button className={classNames("action-btn instruction-btn", (!revokeDate && !countdown && status !== 'expired') ? "" : "disabled")} onClick={openInstructions}> 
                        <i className="fas fa-book"></i>
                        <span>{t('instruction')}</span>
                    </button>) : ""
                    }
                </div>
                
                <div className="click-hint">{t('clickToDownload')}</div>
                
            </div>
    )
}

export default DeviceCard